// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionSummary.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observable, action } from 'mobx';
import { findIndex, forEach } from 'lodash/fp';
import PermissionDetail from './Izenda.PermissionDetail';

export default class PermissionSummary {
  @observable permissionSummary = [];
  @observable selectedRoleId = null;
  @observable collapseAll = true;

  constructor(data: any) {
    data && this.populateData(data);
  }

  /**
   * populate data
   * @param {object} data
   */
  @action
  populateData(data: any): void {
    forEach(item => {
      this.permissionSummary.push({
        id: item.id,
        name: item.name,
        permission: new PermissionDetail(item.permission, false)
      });
    }, data);
    this.setShowingRoleList();
  }

  /**
   * update Role Selected
   * @param  {string} roleId
   */
  @action
  updateRoleSelected(roleId: string): void {
    this.selectedRoleId = roleId;
  }

  /**
   * set Showing Role List
   */
  @action
  setShowingRoleList(): void {
    const permissionIndex = findIndex({ id: this.selectedRoleId }, this.permissionSummary);
    if (permissionIndex > 0) {
      const temp = this.permissionSummary[0];
      this.permissionSummary[0] = this.permissionSummary[permissionIndex];
      this.permissionSummary[permissionIndex] = temp;
    }
  }

  @action
  updateExpendCollapseAll(state: boolean): void {
    this.collapseAll = state;
  }
}



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.PermissionSummary.js